import {mapGetters, mapActions} from 'vuex';
import {
  GETTER_MEDICINE_ORDERS_LOADING,
  GETTER_NEED_ORDER_RELOAD,
  ACTION_SET_MEDICINE_STATE,
} from '@/store/types';
import ServiceOrderCard from '@/components/services/service-order-card';
import EmptyScreen from '@/components/common/empty-screen';
import {
  formatDate,
} from '@/utils/dates';
import {
  MEDICINE_TITLES,
  MEDICINE_SUBTITLES,
} from '@/reference/medicine';
import Routes from '@/router/routes';
import {MedicineService} from '@/services/medicine';

export default {
  components: {
    ServiceOrderCard,
    EmptyScreen,
  },
  data() {
    return {
      searchString: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      medicineOrdersLoading: GETTER_MEDICINE_ORDERS_LOADING,
      needsOrderReload: GETTER_NEED_ORDER_RELOAD,
    }),
    filteredOrders() {
      if (this.searchString === '') return this.serviceOrders;

      return this.serviceOrders
        .filter((serviceOrder) => {
          const address = serviceOrder.address || {};
          const fullDate = formatDate(serviceOrder.daterequested, 'MMMM DD, YYYY');

          return new RegExp(this.searchString.replace(' ', '|'), 'i').test(
            (serviceOrder.firstname || '') +
            (serviceOrder.lastname || '') +
            (address.buildingname || '') +
            (address.city || '') +
            (address.roomnumber || '') +
            (address.street || '') +
            (MEDICINE_TITLES[serviceOrder.ordertype] || '') +
            (MEDICINE_SUBTITLES[serviceOrder.partnercode] || '') +
            fullDate.replace(/[, ]+/g, '|'),
          );
        });
    },
    findAServiceTextStringProps() {
      return {
        labelId: 'txt313',
        props: {
          functions: {
            $1: Routes.SERVICES_FIND_A_SERVICE_PATH,
          },
        },
      };
    },
  },
  mounted() {
    if (this.needsOrderReload) {
      this.fetchOrders();
    }
  },
  methods: {
    ...mapActions({
      setMedicineState: ACTION_SET_MEDICINE_STATE,
    }),
    async fetchOrders() {
      this.setMedicineState({
        loading: true,
      });

      try {
        const {data: {orders}} = await MedicineService.getOrders();
        this.setMedicineState({
          orders,
          loading: false,
          needToReload: false,
        });
      } catch (error) {
        this.setMedicineState({loading: false});
      }
    },
    viewOrderDetails(serviceOrder) {
      this.$router.push({
        name: Routes.MEDICINE_ORDER,
        params: {
          [Routes.MEDICINE_ORDER_ID_PARAM]: serviceOrder.orderid,
        },
      });
    },
  },
}
